/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import { customCodeStyle, StyledMarkdownImage, StyledMarkdownVideo } from './ArticleViewer.styles';
import CustomSummary from './CustomSummary';
import { transformMediaUrl } from '@/utils/apiUtils';

interface MarkdownRendererProps {
  content: string;
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content }) => {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw]}
      components={{
        details: ({ children, ...props }) => <details {...props}>{children}</details>,
        summary: (props) => <CustomSummary {...props} />,
        img: ({ src, alt, ...props }) => {
          const { width, height, style, ...restProps } = props as any;
          return (
            <StyledMarkdownImage
              src={transformMediaUrl(src)}
              alt={alt}
              {...restProps}
              style={style}
            />
          );
        },
        video: ({ src, children, ...props }) => {
          const { width, height, style, ...restProps } = props as any;
          return (
            <StyledMarkdownVideo src={transformMediaUrl(src)} {...restProps} style={style}>
              {children}
            </StyledMarkdownVideo>
          );
        },
        source: ({ src, ...props }) => <source src={transformMediaUrl(src)} {...props} />,
        code({ className, children, ...props }: any) {
          const match = /language-(\w+)/.exec(className || '');
          const isInline = !match;
          return !isInline ? (
            <SyntaxHighlighter
              style={customCodeStyle as any}
              language={match[1]}
              PreTag='div'
              {...props}
            >
              {String(children).replace(/\n$/, '')}
            </SyntaxHighlighter>
          ) : (
            <code className={className} {...props}>
              {children}
            </code>
          );
        },
      }}
    >
      {content}
    </ReactMarkdown>
  );
};

export default MarkdownRenderer;
